"use client";

import { useEffect } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";

import { setFreeText, setInitialLocation, setInitialParams } from "src/store/filter";

import { urlMaker } from "src/services/url-maker";

import { setMapOrListingFinalPath } from "src/helpers/map/commons";

import Button from "src/components/common/button";
import CityDropdown from "src/components/listing-search/filter-items/location-filters/city";
import DistrictsDropdown from "src/components/listing-search/filter-items/location-filters/districts";
import PriceInput from "src/components/listing-search/filter-items/params-filter/range-select/price-input";
import MultiSelectFilter from "src/components/listing-search/filter-items/params-filter/multi-select";
import SingleSelectFilter from "src/components/listing-search/filter-items/params-filter/single-select";

import styles from "./styles.module.css";

const ProjectRadarFilter = ({ filters, criteria, setClose }) => {
  const dispatch = useDispatch();

  const router = useRouter();

  const rangeReduxItems = useSelector((state) => state.filter.rangeselectitems);
  const multiReduxItems = useSelector((state) => state.filter.multiselectitems);
  const singleReduxItems = useSelector((state) => state.filter.singleselectitems);
  const adTypeReduxItems = useSelector((state) => state.filter.adtypesitems);
  const freetextRedux = useSelector((state) => state.filter.freetext);
  const cityRedux = useSelector((state) => state.filter.city);
  const districtRedux = useSelector((state) => state.filter.districts);
  const townsRedux = useSelector((state) => state.filter.towns);
  const localitiesRedux = useSelector((state) => state.filter.localities);

  const createCriteriaParams = () => {
    let params;
    if (criteria?.key === "radar") {
      params = [
        ...criteria?.params,
        {
          key: "price",
          value: {
            max: criteria?.maxPrice,
            min: criteria?.minPrice,
          },
        },
      ];
    } else {
      params = [
        ...criteria?.params,
        {
          key: "price",
          value: {
            max: criteria?.radar?.maxPrice,
            min: criteria?.radar?.minPrice,
          },
        },
      ];
    }
    return params;
  };

  const handleFilterButton = async () => {
    if (setClose) setClose(false);

    const hasLocations = criteria?.location || cityRedux || districtRedux || townsRedux || localitiesRedux;

    const newCriteria = {
      ...criteria,
      params: [...multiReduxItems, ...singleReduxItems, ...adTypeReduxItems],
      freetext: freetextRedux?.value ? freetextRedux : null,
      location: hasLocations
        ? {
            ...criteria?.location,
            city: cityRedux,
            districts: districtRedux,
            towns: townsRedux,
            localities: localitiesRedux,
          }
        : null,
      pagination: {
        key: "pagination",
        pageSize: 10,
        horizontalPage: false,
      },
      radar: {
        key: "radar",
        value: true,
        minPrice: rangeReduxItems?.[0]?.value?.min || null,
        maxPrice: rangeReduxItems?.[0]?.value?.max || null,
      },
    };

    const res = await urlMaker(newCriteria, "default");

    router.push(`/proje-radari${res?.path}`);
  };

  useEffect(() => {
    const criteriaParams = createCriteriaParams();
    dispatch(setFreeText(criteria?.freetext));
    dispatch(setInitialParams(criteriaParams));
    dispatch(setInitialLocation(criteria?.location));
  }, []);

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          <label className={styles.title}>Adres</label>
          <CityDropdown />
          <DistrictsDropdown />
        </div>

        <div className={styles.contentWrapper}>
          {filters?.result[1]?.type === "multi_select" && <MultiSelectFilter filter={filters?.result[1]} />}
          {filters?.result[1]?.type === "single_select" && (
            <>
              <SingleSelectFilter filter={filters?.result[1]} />
            </>
          )}
        </div>

        <div className={styles.contentWrapper}>
          <label className={styles.title}>Fiyat</label>
          <div className={styles.priceContent}>
            <PriceInput filter={filters?.result[0]} />
          </div>
        </div>

        <div className={styles.filterButtonWrap}>
          <div className={styles.filterButton}>
            <Button size="M" onClick={handleFilterButton}>
              Uygula
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.space}></div>
    </div>
  );
};

ProjectRadarFilter.propTypes = {
  filters: PropTypes.object,
  criteria: PropTypes.object,
  setClose: PropTypes.func,
};

export default ProjectRadarFilter;
